import React from 'react';

import { useAppSelector } from '../../../components/hooks';
import { FeaturePatternContainerVisual } from './FeaturePatternContainerVisual';

export function InsertionFeaturePatternContainerVisual() {
  const insertionContainer = useAppSelector((state) =>
    state.application.insertingObjectInfo?.type === 'featurePatternContainer'
      ? state.application.insertingObjectInfo.data
      : null,
  );

  return insertionContainer ? (
    <FeaturePatternContainerVisual style="featurePattern.emphasised" container={insertionContainer} />
  ) : null;
}
